<template>
  <v-btn
    depressed
    :color="corPrincipal"
    v-bind="settings"
    :rounded="rounded"
    v-on="listeners"
    :class="`${ capitalize ? 'text-capitalize' : ''} button-orientation ${ round ? 'round' : ''}` "
  >
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'SGPFormBotaoComponent',

  props: {
    color: {
      type: [String, Array],
      required: false,
      default: 'primary'
    },

    value: {
      type: String,
      required: false,
      default: 'primary'
    },

    rounded: {
      type: Boolean,
      required: false,
      default: true
    },

    capitalize: {
      type: Boolean,
      required: false,
      default: false
    },

    round: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data () {
    return  {
      corPrincipal: this.$props.color
    }
  },

  mounted () {
    if (Array.isArray(this.color)) {
      let iterador = 0
      setInterval(() => {
        this.corPrincipal = this.color[iterador];
        iterador++
        if (iterador == this.color.length) iterador = 0
      }, 700)
    } else {
      this.corPrincipal = this.color
    }

    // console.log('Botão retornando black: ', this.color)
  },

  computed: {
    settings () {
      return {
        ...this.$attrs
      }
    },

    listeners () {
      return {
        ...this.$listeners
      }
    },
  },

  watch: {
    color () {
      if (Array.isArray(this.color)) {
        let iterador = 0
        setInterval(() => {
          this.corPrincipal = this.color[iterador];
          iterador++
          if (iterador == this.color.length) iterador = 0
        }, 700)
      } else {
        this.corPrincipal = this.color
      }
    }
  }
}
</script>

<style lang="scss">
.button-orientation .v-btn__content {
  display: flex;
  align-items: center;
  gap: 4px;

  span {
    font-size: 14px;
    font-style: normal;
    font-family: Roboto;
    text-transform: none;
  }
}

.round {
  border-radius: 8px !important;
}
</style>